import { Component, Input, OnChanges } from '@angular/core';
import { VoltageSpeedVoltageEpisode } from '../../voltage-with-speed.models';
import { buildVoltageAnomalies, filterVoltageAnomalies, VoltageAnomalyFilter } from './voltage-anomalies.utils';

@Component({
  selector: 'app-voltage-speed-anomalies',
  templateUrl: './voltage-anomalies.component.html'
})
export class VoltageSpeedAnomaliesComponent implements OnChanges {
  @Input() episodes: VoltageSpeedVoltageEpisode[] = [];

  filter: VoltageAnomalyFilter = 'all';
  page = 1;
  pageSize = 10;
  rows: ReturnType<typeof buildVoltageAnomalies> = [];
  filteredRows: ReturnType<typeof buildVoltageAnomalies> = [];
  visibleRows: ReturnType<typeof buildVoltageAnomalies> = [];

  ngOnChanges(): void {
    this.rows = buildVoltageAnomalies(this.episodes);
    this.setFilter(this.filter);
  }

  setFilter(filter: VoltageAnomalyFilter): void {
    this.filter = filter;
    this.filteredRows = filterVoltageAnomalies(this.rows, filter);
    this.setPage(1);
  }

  setPage(page: number): void {
    this.page = page;
    this.visibleRows = this.filteredRows.slice((page - 1) * this.pageSize, page * this.pageSize);
  }

  setPageSize(size: number): void {
    this.pageSize = size;
    this.setPage(1);
  }
}
